module.exports = __webpack_public_path__ + "img/logo-verso-vendas.78ea3494.png";